import api from './api';

export type DealSource = 'apt_trade' | 'silv_trade';
export interface DealType { type_name: string; exclusive_area: number }
export interface DealRecord {
  apt_name: string;
  exclusive_area: number;
  contract_date: string;
  floor: number | null;
  amount_manwon: number;
  transaction_method: string;
  rights_type: string;
  cancelled: boolean;
  cancel_date: string | null;
}
export interface DealComparison {
  status: 'ok' | 'no_data' | 'unavailable' | 'partial';
  reason: string | null;
  property_id: number;
  source: DealSource;
  source_label: string;
  source_url: string;
  period: { start: string; end: string; months: number };
  fetched_at: string | null;
  match_basis: string;
  area_tolerance_sqm: number;
  available_types: DealType[];
  selected_type: DealType | null;
  records: DealRecord[];
  summary: { count: number; cancelled_count: number; median_manwon: number | null; min_manwon: number | null; max_manwon: number | null } | null;
  comparison: { available: boolean; reason: string; message: string };
  benefit_access: 'public' | 'unlocked' | 'login_required' | 'request_required';
  excluded_rights_count?: number;
}

export async function getDealComparison(
  propertyId: number, source: DealSource, typeName?: string, signal?: AbortSignal,
): Promise<DealComparison> {
  const { data } = await api.get<DealComparison>(`/properties/${propertyId}/deal-comparison/`, {
    params: { source, ...(typeName ? { type_name: typeName } : {}) }, signal, timeout: 35000,
  });
  return data;
}
